import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/layouts',
    name: 'layouts',
    component: () => import('./views/LayoutsList'),
    meta: {
      auth: true
    }
  },
  {
    path: '/layouts/new',
    name: 'layouts.new',
    component: () => import('./views/LayoutsNew'),
    meta: {
      auth: true
    }
  },
  {
    path: '/layouts/:id',
    name: 'layouts.edit',
    component: () => import('./views/LayoutsEdit'),
    meta: {
      auth: true
    }
  }
])
